import cx from 'classnames'
import styles from './Reminder.css'

const Reminder = ({ type, color, className, children }) => {
  const clz = cx(
    styles.reminder,
    {
      [className]: className
    }
  )

  return (
    <div className={clz}>
      <p>
        <b>本畫面各項作業功能，經資料轉換或確認時，即視同合約生效。</b>
        <br />
        故請 貴公司妥善保管密碼，並謹慎作業。
        <br />
        客服地址：台北市南港區115三重路66號14樓 (南港軟體園區三期辦公大樓)
        <br />
        本站所有內容，非經授權不得任意使用、列印、公開播送如有違反， 您應對香港商雅虎資訊股份有限公司台灣分公司負損害賠償責任。
      </p>
    </div>
  )
}

export default Reminder
